import React, { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Pencil, Trash2 } from 'lucide-react';
import './ActionMenu.css';

const MENU_WIDTH = 160;
const MENU_HEIGHT = 96;

const MENU_STYLE = {
  position: 'fixed',
  width: MENU_WIDTH,
  background: '#fff',
  borderRadius: 8,
  boxShadow: '0 4px 16px rgba(0, 0, 0, 0.15)',
  border: '1px solid #dee2e6',
  zIndex: 9999,
  overflow: 'hidden',
  pointerEvents: 'auto',
};

const ActionMenu = ({ onAction, anchorRef }) => {
  const [position, setPosition] = useState(null);

  useLayoutEffect(() => {
    let rafId = null;

    const updatePosition = () => {
      const anchor = anchorRef?.current;
      if (!anchor) {
        rafId = requestAnimationFrame(updatePosition);
        return;
      }

      const rect = anchor.getBoundingClientRect();
      let top = rect.bottom + 4;
      let left = rect.right - MENU_WIDTH;

      if (top + MENU_HEIGHT > window.innerHeight - 8) {
        top = rect.top - MENU_HEIGHT - 4;
      }

      if (left < 8) {
        left = 8;
      } else if (left + MENU_WIDTH > window.innerWidth - 8) {
        left = window.innerWidth - MENU_WIDTH - 8;
      }

      setPosition({ top, left });
    };

    updatePosition();
    window.addEventListener('scroll', updatePosition, true);
    window.addEventListener('resize', updatePosition);

    return () => {
      if (rafId != null) cancelAnimationFrame(rafId);
      window.removeEventListener('scroll', updatePosition, true);
      window.removeEventListener('resize', updatePosition);
    };
  }, [anchorRef]);

  const handleClick = (action, e) => {
    e.stopPropagation();
    e.preventDefault();
    onAction(action);
  };

  if (!position) return null;

  return createPortal(
    <div
      className="action-menu"
      style={{ ...MENU_STYLE, top: position.top, left: position.left }}
      onMouseDown={(e) => e.stopPropagation()}
      role="menu"
    >
      <button
        type="button"
        className="action-menu-item"
        onClick={(e) => handleClick('edit', e)}
        role="menuitem"
      >
        <Pencil size={16} />
        <span>Edit</span>
      </button>

      <button
        type="button"
        className="action-menu-item delete"
        onClick={(e) => handleClick('delete', e)}
        role="menuitem"
      >
        <Trash2 size={16} />
        <span>Delete</span>
      </button>
    </div>,
    document.body
  );
};

export default ActionMenu;
